import { Component, inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { AuthService } from 'src/app/core/services/auth';
import { LoaderService } from 'src/app/core/services/loader';
import { NotificationService } from 'src/app/core/services/notification';

@Component({
  selector: 'app-recovery-pass',
  templateUrl: './recovery-pass.component.html',
  styleUrls: ['./recovery-pass.component.scss'],
})
export class RecoveryPassComponent extends BaseComponent implements OnInit {
  authService = inject(AuthService);

  formGroup!: UntypedFormGroup;

  ngOnInit(): void {
    this.buildForm();
  }

  sendRecoveryPassEmailRequest(): void {
    const { email } = this.formGroup.getRawValue();

    const loaderRef = this.loader.open(
      'Enviando email de recuperação de senha...'
    );

    this.authService
      .sendRecoveryPassEmail(email)
      .subscribe(() => this.sendRecoveryPassEmailSuccess())
      .add(() => loaderRef.close());
  }

  private buildForm(): void {
    this.formGroup = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
    });
  }

  private sendRecoveryPassEmailSuccess(): void {
    this.router.navigate(['autenticacao', 'entrar']);

    this.notification.success(
      'Um email foi enviado contendo o link de recuperação de senha'
    );
  }
}
